import { render, staticRenderFns } from "./preferred-onboard-form.vue?vue&type=template&id=50d3c6a2&scoped=true"
import script from "./preferred-onboard-form.vue?vue&type=script&lang=ts"
export * from "./preferred-onboard-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3c6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d3c6a2')) {
      api.createRecord('50d3c6a2', component.options)
    } else {
      api.reload('50d3c6a2', component.options)
    }
    module.hot.accept("./preferred-onboard-form.vue?vue&type=template&id=50d3c6a2&scoped=true", function () {
      api.rerender('50d3c6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/preferred-onboard-form.vue"
export default component.exports